import { render, staticRenderFns } from "./EditTasksModal.vue?vue&type=template&id=0190f8c4&"
import script from "./EditTasksModal.vue?vue&type=script&lang=js&"
export * from "./EditTasksModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTasksModal.vue?vue&type=style&index=0&id=0190f8c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports